import { render, staticRenderFns } from "./GroupSimulationCompetenciesPage.vue?vue&type=template&id=c1c993f4"
import script from "./GroupSimulationCompetenciesPage.vue?vue&type=script&lang=js"
export * from "./GroupSimulationCompetenciesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports